import React from 'react';
import { useLocation } from 'react-router-dom';
import TabPublicGroup from '../components/TabPublicGroup';
import { useSelector } from 'react-redux';
import { selectAuthProfiles } from '../redux/selectors/authSelectors';

const GlobalPage = () => {
  const location = useLocation();
  const profiles = useSelector(selectAuthProfiles);

  if (!profiles?.news) return null;

  return (
    <TabPublicGroup
      name='global'
      title='Main Cybersecurity News'
      profiles={profiles}
      path={location.pathname}
    />
  );
};

export default GlobalPage;
